<template>
  <div class="dropdown-container">
  </div>
</template>

<script>
  export default {
    name: "ChangeLineActions",
    components: {
    },
    data() {
      return {
        line: {},
        optionsLine: [{
          id: 0,
          value: 0,
          content: "线路1",
        }, {
          id: 1,
          value: 1,
          content: "线路2",
        }, {
          id: 2,
          value: 2,
          content: "线路3",
        }, {
          id: 3,
          value: 3,
          content: "线路4",
          noSave: true,
        }, {
          id: 4,
          value: 4,
          content: "线路5",
          noSave: true,
        }],
      }
    },

    mounted() {
      let lineId = this.$store.getters.getLineId
      this.line = this.optionsLine[lineId]
    },

    methods: {
      showChangeLine() {
        this.$createActionSheet({
          title: '切换线路',
          data: this.optionsLine,
          active: this.line.id,
          onSelect: (item, index) => {
            this.$store.dispatch("SetLine", this.optionsLine[index])
            this.line = this.optionsLine[index]

            this.$createToast({
              txt: `切换到${item.content}`,
              type: "text",
              time: 1000,
            }).show()
            this.$emit("changeLine")
          }
        }).show()
      }
    },
    computed: {
      currentLineDesc() {
        if (this.line && this.line.content) {
          return this.line.content
        } else {
          return "线路1"
        }
      }

    }
  }

</script>

<style lang="scss" scoped>

</style>
